(function($) {

	'use strict'

	var init = function() {
		initBreakpoints()
		initCarousel()
		initEvent()
	}

	var responsiveBreakpoints = { mobile: 0, tablet: 768, laptop: 992, desktop: 1200}
	var currentBreakpoint
	var initBreakpoints = function() {
		windowResizeHandler()
		window.addEventListener('resize', windowResizeHandler);
	}
	var windowResizeHandler = function(event) {
		var w = document.documentElement.clientWidth;
		if(w > responsiveBreakpoints.desktop)
			currentBreakpoint = 'desktop'
		else if (w > responsiveBreakpoints.laptop)
			currentBreakpoint = 'laptop'
		else if (w > responsiveBreakpoints.tablet)
			currentBreakpoint = 'tablet'
		else
			currentBreakpoint = 'mobile'
	}

	var $owlCarousel
	var owlCarouselItemIndex
	var owlCarouselItemCount
	var navSteps = { mobile: 1, tablet: 3, laptop: 4, desktop: 4}
	var initCarousel = function() {

		$owlCarousel = $('.soon-owl-carousel')
        $owlCarousel.owlCarousel({
			dots: false,
			loop: false,
            responsive:{
                0:{
					items: 1,
					mouseDrag: true,
					touchDrag: true,
					pullDrag: true,
					autoWidth:true,
					center: true,
					margin: 20,
                },
                768:{
					items: 3,
					mouseDrag: false,
					touchDrag: false,
					pullDrag: false,
                },
                992:{
					items: 4,
					mouseDrag: false,
					touchDrag: false,
					pullDrag: false,
                }
			},
			onInitialized: owlCarouselInitializedHandler,
			onChanged: owlCarouselChangedHandler
        })
	}
	
	var owlCarouselInitializedHandler = function(event) {
		owlCarouselItemCount = event.item.count
	}
	var owlCarouselChangedHandler = function(event) {
		owlCarouselItemIndex = event.item.index
		$('.soon__header__nav button').removeClass('inactive')
		
		if(owlCarouselItemIndex == 0) 
			$('.soon__header__nav button#prev').addClass('inactive')

		if(owlCarouselItemIndex + navSteps[currentBreakpoint] >= event.item.count) 
			$('.soon__header__nav button#next').addClass('inactive')
	}

	var initEvent = function(){
		$('.soon__header__nav button').on('click', slide)
	}

	var slide = function(event) {
		if($(this).attr('id') == 'prev') {
			$owlCarousel.trigger('to.owl.carousel', [owlCarouselItemIndex - navSteps[currentBreakpoint], 300])
		} else {
			$owlCarousel.trigger('to.owl.carousel', [owlCarouselItemIndex + navSteps[currentBreakpoint], 300])
		}
	}

	$(document).ready(function() {
		if($('section.soon').length){
			init()
		}
	})

})(jQuery)